import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CocaColaValuesGameRoutingModule } from './coca-cola-values-game-routing.module';
import { CocaColaValuesGameComponent } from './coca-cola-values-game.component';
import { CocaColaService } from './coca-cola.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { ValuesGamePlayerCoreModule } from '../talent-litmus-core/values-game-player-core';

@NgModule({
  declarations: [CocaColaValuesGameComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    ReactiveFormsModule,
    ValuesGamePlayerCoreModule,
    CocaColaValuesGameRoutingModule,
  ],
  providers: [CocaColaService],
})
export class CocaColaValuesGameModule {}
